import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  writeBatch,
} from 'firebase/firestore';
import { getFirebaseFirestore } from '../firebase/index';

export const removeInstagramAccountFromWorkspace = async (
  workspaceId: string,
  accountId: string
): Promise<void> => {
  const db = await getFirebaseFirestore();
  const accountRef = doc(
    db,
    'workspaceIntegrations',
    workspaceId,
    'providers',
    'instagram',
    'accounts',
    accountId
  );
  const credentialsRef = collection(accountRef, 'credentials');
  const credentialsSnapshot = await getDocs(credentialsRef);

  const batch = writeBatch(db);
  credentialsSnapshot.forEach(credentialDoc => {
    batch.delete(credentialDoc.ref);
  });
  batch.delete(accountRef);
  await batch.commit();

  // Clean up empty provider doc to keep Firestore tidy.
  const accountsSnapshot = await getDocs(
    collection(
      db,
      'workspaceIntegrations',
      workspaceId,
      'providers',
      'instagram',
      'accounts'
    )
  );
  if (accountsSnapshot.empty) {
    const providerRef = doc(
      db,
      'workspaceIntegrations',
      workspaceId,
      'providers',
      'instagram'
    );
    await deleteDoc(providerRef);
  }
};
